import { App } from './components/app/app';
import './global.css';

const app: App = new App();
app.start();
